module.exports.components = {
  "forgotpassword": require('./forgotPasswordAction/index'),
  "emailsent": require('./emailSendAction/index'),
  "resetpassword": require('./resetPasswordAction/index'),
  "activateaccount": require('./activateAccountAction/index'),
  "activateaccountresult": require('./activateAccountResultAction/index'),
  "passwordsavedaction": require('./passwordSavedAction/index')
};

module.exports.Type = {
  FORGOT_PASSWORD: "forgotpassword",
  EMAIL_SENT: "emailsent",
  RESET_PASSWORD: "resetpassword",
  ACTIVATE_ACCOUNT: "activateaccount",
  ACTIVATE_ACCOUNT_RESULT: "activateaccountresult",
  PASSWORD_SAVED_ACTION: "passwordsavedaction"
};
